import * as z from "zod/v4";

export const createLandmarkGlobalIntegration = {
  name: "createLandmarkGlobalIntegration" as const,
  input: z.object({
    username: z.string(),
    password: z.string(),
    shippingLaneRegion: z.string(),
    clientId: z.string(),
  }),
  output: z.null(),
};
